// import { API_FIELDS } from 'library/constants/models/wishlist-item';
import * as constants from './constants';
import { FILTER_KEYS, SORT_DIRECTION as DIRECTIONS } from './fixtures';

// todo - consider move filters/query data to separate reducers
export const initialState = {
  loading: false,
  data: [],
  error: null,
  filters: {
    [FILTER_KEYS.PAGE]: 1,
    [FILTER_KEYS.PER_PAGE]: 20,
    [FILTER_KEYS.HAS_MORE]: false,
    [FILTER_KEYS.SORT_DIRECTION]: DIRECTIONS.DESC,
    // [FILTER_KEYS.TYPE]: 'item',
    // [FILTER_KEYS.QUANTITY]: null,
    [FILTER_KEYS.CATEGORIES]: [],
    [FILTER_KEYS.MANUFACTURERS]: [],
    [FILTER_KEYS.STORAGE]: [],
    [FILTER_KEYS.TAGS]: [],
    [FILTER_KEYS.ITEMS]: [],
  },
};
export const wishlistItemsReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
  case constants.GET_WISHLIST_ITEMS:
    return {
      ...state,
      loading: true,
    };
  case constants.SET_WISHLIST_ITEMS_FILTERS:
    return {
      ...state,
      // data: [],
      filters: {
        ...(action.payload && Object.keys(action.payload).length !== 0 ? {
          ...state.filters,
          ...action.payload,
          [FILTER_KEYS.PAGE]: 1,
          [FILTER_KEYS.HAS_MORE]: false,
        } : JSON.parse(JSON.stringify(initialState.filters))),
      },
    };
  // case constants.SET_WISHLIST_ITEMS_QUERY:
  //   return {
  //     ...state,
  //     query: {
  //       data: action.payload,
  //     },
  //   };
  case constants.GET_WISHLIST_ITEMS_SUCCESS:
    return {
      ...state,
      loading: false,
      // eslint-disable-next-line max-len
      data: [...(action.payload.filters[FILTER_KEYS.PAGE] !== 1 ? state.data : []), ...action.payload.data],
      filters: {
        ...state.filters,
        ...action.payload.filters,
        /* eslint-disable-next-line max-len */
        // [FILTER_KEYS.CATEGORIES]: [...state.filters[FILTER_KEYS.CATEGORIES], ...(action.payload.filters[FILTER_KEYS.CATEGORIES] || [])],
        // eslint-disable-next-line max-len
        // [FILTER_KEYS.MANUFACTURERS]: [...state.filters[FILTER_KEYS.MANUFACTURERS], ...(action.payload.filters[FILTER_KEYS.MANUFACTURERS] || [])],
        // eslint-disable-next-line max-len
        // [FILTER_KEYS.STORAGE]: [...state.filters[FILTER_KEYS.STORAGE], ...(action.payload.filters[FILTER_KEYS.STORAGE] || [])],
      },
    };
  case constants.GET_WISHLIST_ITEMS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.payload,
      filters: {
        ...state.filters,
        [FILTER_KEYS.HAS_MORE]: false,
      /* eslint-disable-next-line max-len */
      // [FILTER_KEYS.CATEGORIES]: [...state.filters[FILTER_KEYS.CATEGORIES], ...(action.payload.filters[FILTER_KEYS.CATEGORIES] || [])],
      // eslint-disable-next-line max-len
      // [FILTER_KEYS.MANUFACTURERS]: [...state.filters[FILTER_KEYS.MANUFACTURERS], ...(action.payload.filters[FILTER_KEYS.MANUFACTURERS] || [])],
      // eslint-disable-next-line max-len
      // [FILTER_KEYS.STORAGE]: [...state.filters[FILTER_KEYS.STORAGE], ...(action.payload.filters[FILTER_KEYS.STORAGE] || [])],
      },
    };
  case constants.UPDATE_WISHLIST_ITEMS:
    return {
      ...state,
      data: action.payload.data,
    };
  case constants.RESET_WISHLIST_ITEMS:
    return JSON.parse(JSON.stringify(initialState));
  default:
    return state;
  }
};

const initialActionState = {
  selectedIds: [],
  openedItemId: null,
};

export const wishlistItemsActionReducer = (state = initialActionState, action) => {
  switch (action.type) {
  case constants.SELECT_WISHLIST_ITEM:
    return { ...state, selectedIds: [...state.selectedIds, action.payload.id] };
  case constants.DESELECT_WISHLIST_ITEM:
    return { ...state, selectedIds: state.selectedIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_MANY_WISHLIST_ITEMS:
    return {
      ...state,
      selectedIds: state.selectedIds.filter((id) => !action.payload.ids.includes(id)),
    };
  case constants.OPEN_WISHLIST_ITEM:
    return { ...state, openedItemId: action.payload.id };
  case constants.CLOSE_WISHLIST_ITEM:
    return { ...state, openedItemId: null };
  case constants.RESET_WISHLIST_ITEMS_ACTIONS:
    return initialActionState;
  default:
    return state;
  }
};
